module.exports = __webpack_public_path__ + "static/media/та.857e54cf.mp3";